module.exports = __webpack_public_path__ + "img/loading.e6e7faf5.gif";